<mat-card>
    <div class="row">
        <prl-label value="label.dashboard.topzones"></prl-label>
        <mx-info-tooltip [config]="topZonesConfig"></mx-info-tooltip>
    </div>
    <prl-dashboard-top-zone *ngFor="let zone of topZones" [zone]="zone"></prl-dashboard-top-zone>
</mat-card>